// ============================================================================
// Max Messenger initData resolver
// ----------------------------------------------------------------------------
// Возвращает raw initData (URL-encoded query string) для авторизации на бэкенде.
// В dev-режиме миниап запускается в браузере вне webview Max, поэтому initData
// читается из VITE_INIT_DATA (.env.dev / .env.local). Во всех остальных
// режимах initData берётся из window.WebApp (Max Messenger webview).
// ============================================================================

export interface MaxAuthPayload {
  initData: string;
  user?: {
    id: number;
    first_name: string;
    last_name?: string;
    photo_url?: string;
  };
}

function parseUser(initData: string): MaxAuthPayload["user"] | undefined {
  try {
    const rawUser = new URLSearchParams(initData).get("user");
    if (!rawUser) return undefined;
    return JSON.parse(decodeURIComponent(rawUser)) as MaxAuthPayload["user"];
  } catch {
    return undefined;
  }
}

/** Пытается прочитать initData из env (dev-режим) либо из window.WebApp. */
export function getMaxAuthPayload(): MaxAuthPayload | null {
  if (import.meta.env.DEV) {
    const initData = import.meta.env.VITE_INIT_DATA;
    console.log(
      `[INIT DATA] Dev mode: ${import.meta.env.MODE}, VITE_API_URL=${import.meta.env.VITE_API_URL}, VITE_API_PATH=${import.meta.env.VITE_API_PATH}`,
    );
    if (!initData) {
      console.warn(
        "[INIT DATA] VITE_INIT_DATA пуст. Укажите initData от Max Messenger в .env.local",
      );
      return null;
    }
    console.log("[INIT DATA] initData взят из VITE_INIT_DATA (env):", initData);
    return { initData, user: parseUser(initData) };
  }

  if (typeof window === "undefined") return null;
  const initData = window.WebApp?.initData;
  if (!initData) {
    console.warn("[INIT DATA] initData не найден в window.WebApp");
    return null;
  }
  console.log("[INIT DATA] initData взят из window.WebApp (webview Max)");
  return { initData, user: window.WebApp?.initDataUnsafe?.user };
}
